module.exports = __webpack_public_path__ + "static/media/car3.4e31a64f.png";